/*eslint-disable no-mixed-operators */
/*eslint-disable array-callback-return */
/*eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from 'react';
import CustomClientError from '../../../../../Member/errorhandling/CustomClientError';
import ClaimListFilter from './ClaimListFilter';
import { Container, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import GridSkeleton from './GridSkeleton';
import ClaimListGrid from './ClaimListGrid';
import { setSearchParams } from 'src/redux/admin/claimsSlice';
import { useDispatch, useSelector } from 'react-redux';

const ClaimList = ({
  claimDataList,
  dataFetching,
  isAPIFailed,
  selectedUserFirstName,
  selectedUserEmail,
  ...otherProps
}) => {
  const setUniqueData = () => {
    const uniqueNames = [],
      uniqueTypes = [];
    claimDataList.forEach((element) => {
      if (!uniqueNames.includes(element.PatientName)) {
        uniqueNames.push(element.PatientName);
      }
      if (!uniqueTypes.includes(element.Product)) {
        uniqueTypes.push(element.Product);
      }
    });
    setUniqueNames(uniqueNames);
    setUniqueTypes(uniqueTypes);
  };

  const searchByClaimNumber = (data, claimNo) => {
    return data?.filter((ele) => {
      if (
        ele.Claimnumber !== '' &&
        ele.Claimnumber != null &&
        ele.ProviderName != null
      ) {
        return (
          ele.Claimnumber.toLowerCase().includes(
            claimNo.toString().toLowerCase(),
          ) ||
          ele.ProviderName.toLowerCase().includes(
            claimNo.toString().toLowerCase(),
          )
        );
      }
    });
  };

  const searchByNameORType = (data, label, values) => {
    const filteredResults = [];
    data.forEach((eachClaim) => {
      values.filter((eachValue) => {
        if (eachClaim[`${label}`] === eachValue) {
          filteredResults.push(eachClaim);
        }
      });
    });
    return filteredResults;
  };
  const filterByDate = (data, selectedValue, startDate, endDate) => {
    const dateFilterdData = [];
    if (selectedValue.label === 'Date Range') {
      data.filter((ele) => {
        if (
          moment(ele.ServiceDate).format('YYYY-MM-DD') >=
            moment(startDate).format('YYYY-MM-DD') &&
          moment(ele.ServiceDate).format('YYYY-MM-DD') <=
            moment(endDate).format('YYYY-MM-DD')
        ) {
          dateFilterdData.push(ele);
        }
      });
    } else {
      data.filter((ele) => {
        const comparisonField =
          selectedValue.label === 'Year-to-Date'
            ? moment(new Date()).startOf('year').format('YYYY-MM-DD')
            : moment()
                .subtract(+selectedValue.value, 'months')
                .format('YYYY-MM-DD');
        if (
          moment(ele.ServiceDate).format('YYYY-MM-DD') >=
          moment(comparisonField).format('YYYY-MM-DD')
        ) {
          dateFilterdData.push(ele);
        }
      });
    }
    return dateFilterdData;
  };

  const {
    searchParms: {
      claimNumber,
      claimType,
      claimDuration,
      startDate: strtDate,
      endDate: enDate,
      pageSize,
      pageNumber,
    },
    claimsResult,
    activeUserOID,
  } = useSelector(({ claims }) => claims);
  useEffect(() => {
    if (claimDataList?.length > 0) {
      const filteredDataByClaimNumber =
        claimNumber !== '' && claimDataList?.length > 0
          ? searchByClaimNumber(claimDataList, claimNumber)
          : claimDataList;
      const filteredDataByType =
        claimType?.length > 0 && filteredDataByClaimNumber?.length > 0
          ? searchByNameORType(filteredDataByClaimNumber, 'Product', claimType)
          : filteredDataByClaimNumber;
      const filteredDataByDate =
        claimDuration !== '' && filteredDataByType?.length > 0
          ? filterByDate(filteredDataByType, claimDuration, strtDate, enDate)
          : filteredDataByType;
      setFilteredClaimsData(filteredDataByDate);
    }
  }, [claimDataList, claimNumber, claimType, claimDuration, enDate]);

  const [uniqueNames, setUniqueNames] = useState([]);
  const [uniqueTypes, setUniqueTypes] = useState([]);

  const [filteredClaimsData, setFilteredClaimsData] = useState([]);
  //Settting up unique names when ClaimList Changes
  useMemo(() => {
    setFilteredClaimsData(claimDataList);
    if (claimDataList?.length > 0) {
      setUniqueData();
    } else {
      setUniqueNames([]);
      setUniqueTypes([]);
    }
  }, [claimDataList]);

  return (
    <>
      <div className="claims-list-page">
        <div className="claims-list-page-filters filter-bar-border-top filter-bar-border-bottom mt-4 mb-4">
          <div className="container-offset">
            <ClaimListFilter
              uniqueNames={uniqueNames}
              uniqueTypes={uniqueTypes}
            />
          </div>
        </div>
        <div className="container-offset">
          <Row className="mt-4 claims-list-grid">
            {dataFetching ? (
              <GridSkeleton />
            ) : claimDataList?.length > 0 ? (
              <ClaimListGrid
                dataFetching={dataFetching}
                isAPIFailed={isAPIFailed}
                filteredClaimsData={filteredClaimsData}
                preserveData={otherProps.preserveData}
                selectedUserFirstName={selectedUserFirstName}
                selectedUserEmail={selectedUserEmail}
                userOID={otherProps.userOID}
                memberType={otherProps.memberType}
              />
            ) : (
              <Col>
                <CustomClientError
                  CustomClasses="p-0 m-0"
                  ErrorHeading="No Claims found!"
                  ErrorMessage="We could not find any Claims for the selected Claim Category."
                />
              </Col>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default ClaimList;
